import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import { QuotingToolService } from '../../quoting-tool.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Router } from '@angular/router';
import { WarningComponent } from "../../warning/warning.component";
import { MatDialog } from "@angular/material/dialog";
import { CommonService } from 'src/app/core/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, take } from 'rxjs';
export interface Row {
  name: string;
  unit: string;
  total: string;
}
@Component({
  selector: 'app-quotation-and-order',
  templateUrl: './quotation-and-order.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class QuotationAndOrderComponent implements OnInit {
  getImagePath: any = environment.image_path;
  dataSource = new MatTableDataSource<Row>([]);
  projectID: any;
  totalCost: number = 0;
  hasRemainingMPNPrice = false;
  isProcessing = false;
  localToken: any;
  isAccessTokenPresent: boolean = !!localStorage.getItem('customer_access_token') || !!localStorage.getItem('quote_token');

  multiplierValues: number[] = [10, 20, 50, 100, 200, 250, 500, 750, 1000, 2500, 5000, 7500, 10000];
  selectedMultiplier: number = 1;
  totalFinalCosts: any = []
  totalfinalcost: any = []


  quotationData: any[] = []; // Store API response
  dynamicColumns: string[] = []; // Store column names dynamically

  totalSellingPrice: number = 0;
  totalFinalPrice: number = 0;
  sellingPrice: number = 0;
  finalPrice: number = 0;
  totaltestingProcessCost: number = 0;
  totalpackagingProcessCost: number = 0;
  totalinventoryProcessCost: number = 0;
  testingInput: number = 0;
  packagingInput: number = 0;
  inventoryInput: number = 0;
  grandTotalPartB: number = 0;

  perUnitSellingPrice: number = 0;
  perUnitFinalPrice: number = 0;

  totalPartA: number = 0;
  totalPartB: number = 0;
  totalPartC: number = 0;
  totalPartD: number = 0;

  perUnitPartA: number = 0;
  perUnitPartB: number = 0;
  perUnitPartC: number = 0;
  perUnitPartD: number = 0;
  totalCommercials: any
  totalMPNPrice: any;
  validEbomCount: any;
  remainingMPNPrice: any = []
  totalPartAForEachRow: any = []
  totalPartBForEachRow: any = []
  totalPartCForEachRow: any = []
  totalPartDForEachRow: any = []
  sellingTotalForEachRow: any = []
  finalTotalForEachRow: any = []
  isLoading: boolean = false;
  totalBareMinimum: number = 0;
  partDBareMinimum: any

  isPartAOpen = false;
  isPartBOpen = false;
  isPartCOpen = false;
  isPartDOpen = false;
  private isModalOpen = false;
  private previousData: any;
  getStoreDataE: any

  quotationViewDetails: any = {
    rio_type: '',
    quotation_prposal_heading: '',
    createdOn: '',
    quantity: '--',
    cost_range: '--',
    proposal: []
  };


  progress: number = 0;  // Progress percentage

  constructor(
    private quotingService: QuotingToolService,
    private notificationService: NotificationService,
    private router: Router,
    public dialog: MatDialog,
    private modalService: NgbModal,
    public commonService: CommonService,
    private cdr: ChangeDetectorRef
  ) {
    this.localToken = localStorage.getItem('customer_access_token');
    this.initializeTotals();
  }


  ngOnInit() {
    this.projectID = localStorage.getItem('projectID');
    this.GetQuotationData();
    const tempFunction = this.commonService.getQuoteCallback(); // Get the initial value
    this.getStoreDataE = tempFunction();
    this.previousData = tempFunction();

    // Store the interval ID
    const intervalId = setInterval(() => {
      const currentDataFunc = this.commonService.getQuoteCallback(); // Get the current value
      const currentData = currentDataFunc();

      if (this.previousData && (currentData !== this.previousData)) {

        this.previousData = currentData; // Update previous data
        this.getStoreDataE = currentData; // Update stored data

        this.isAccessTokenPresent = true; // Update the token presence
        this.isModalOpen = false; // Close the modal
        this.uploadVendorPricing(); // Call your API whenever data changes

        // Clear the interval
        clearInterval(intervalId);
      }
    }, 1000);
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnDestroy(){
    this.quotingService.updateQuotePercentage("");
    this.modalService.dismissAll();
  }

  toggleSection(part: string) {
    switch (part) {
      case 'partA':
        this.isPartAOpen = !this.isPartAOpen;
        break;
      case 'partB':
        this.isPartBOpen = !this.isPartBOpen;
        break;
      case 'partC':
        this.isPartCOpen = !this.isPartCOpen;
        break;
      case 'partD':
        this.isPartDOpen = !this.isPartDOpen;
        break;
    }
  }

  getTotal(element: any): number {
    const multiplier = this.selectedMultiplier ? Number(this.selectedMultiplier) : 1; // Default to 1 if null
    const totalString = element.total.replace(/[^0-9.-]+/g, '');  // Remove dollar sign and other non-numeric characters
    const total = Number(totalString);
    if (!isNaN(multiplier) && !isNaN(total)) {
      return total * multiplier;
    } else {
      return total;
    }
  }

  hasCustomerAccessToken(): boolean {
    return this.localToken !== null && this.localToken !== '';
  }

  GoToDashboard() {
    this.router.navigate(['/customer/quotation-proposal']);
  }



  GetQuotationData() {
    if (!this.isAccessTokenPresent) {
      // if (this.router.url === "/quotation") {
      //   return;
      // }

      // Add this guard
      if (this.isModalOpen) {
        return;
      }

      this.isModalOpen = true;

      const dialogRef = this.dialog.open(WarningComponent, {
        width: '500px',
        disableClose: true,
        panelClass: 'custom-dialog',
        data: { source: 'submitBOMFile' }
      });

      // Change to this subscription pattern
      const authSub = dialogRef.componentInstance.authSuccess
        .pipe(take(1))  // Add this
        .subscribe(() => {
          this.isAccessTokenPresent = true;
          this.isModalOpen = false;
          this.uploadVendorPricing();
          authSub.unsubscribe();  // Add this
        });

      dialogRef.afterClosed().subscribe(() => {
        this.isModalOpen = false;
      });

    } else {
      this.uploadVendorPricing();
    }
  }

  uploadVendorPricing() {
    this.quotingService.updateQuotePercentage('0%');

    // Add this guard
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    let reqJSON = {
      iProjectID: this.projectID
    };
    this.isLoading = true;
    setTimeout(() => {
      this.getPercentage();
    }, 7000);
    this.quotingService.FetchVendorPrice(reqJSON)
      .pipe(
        finalize(() => this.isProcessing = false)  // Add this
      )
      .subscribe(async (resJSON: any) => {
        if (resJSON.code == 200) {
          this.isLoading = false;
          this.fetchQuotationData();
        } else {
          this.notificationService.showError(`${resJSON.message}`, "");
          this.quotingService.updateQuotePercentage('');
        }
      });
  }

  dataFetch: boolean = false;
  fetchQuotationData(): void {
    this.isLoading = true;
  
    this.quotingService.GetQuotationData(this.projectID).subscribe((resJSON: any) => {
      if (resJSON.code !== 200) {
        this.isLoading = false;
        this.quotingService.updateQuotePercentage("")
        this.notificationService.showError(resJSON.message, "");
        return;
      }
      this.quotingService.updateQuotePercentage("")
      this.isLoading = false;
      this.quotationViewDetails = resJSON.data;
      this.dataFetch = true;
  
      this.totalFinalCosts = resJSON.data.map((item: any) => {
        return item?.totalquotationcost?.find((obj: any) => obj.totalfinalcost)?.totalfinalcost || null;
      });
  
      // Calculate totals
      this.calculateTotalsForAllParts();
  
    });
  }
  
  getRemainingMPNPrice(index: number): any[] {
    return (
      this.quotationViewDetails[index]?.totalquotationcost?.find(
        (obj: any) => obj.EBomCost
      )?.EBomCost?.mouserPrice?.remainingMPNPrice || []
    );
  }
  
  calculateTotalsForAllParts() {
    this.totalPartAForEachRow = this.totalFinalCosts.map((cost: any) => {
      return (
        (cost?.part1rmccost?.totalEbomCost || 0) +
        (cost?.part1rmccost?.totalBarePcbCost || 0) +
        (cost?.part1rmccost?.totalFreightCost || 0) +
        (cost?.part1rmccost?.totalInsuranceCost || 0) +
        (cost?.part1rmccost?.totalDutiesPartsPCBCost || 0) +
        (cost?.part1rmccost?.totalClearingBankChargeCost || 0) +
        (cost?.part1rmccost?.totalMortalityCost || 0)
      );
    });

    this.totalPartBForEachRow = this.totalFinalCosts.map((cost: any, i: any) => {
      return (
        // this.calculatePCBAssemblyCost(i) +
        (cost?.part2processcost?.totalSMTThroughHoleCost || 0)+
        (cost?.part2processcost?.totalpackagingBoxPCBACost || 0)
      );
    });


    this.totalPartCForEachRow = this.totalFinalCosts.map((cost: any) => {
      return (
        (cost?.part3others?.totaloverheadsCost || 0) +
        (cost?.part3others?.totalmarkupCost || 0)
      );
    });

    this.totalPartDForEachRow = this.totalFinalCosts.map((cost: any) => {
      return (
        (cost?.part4onetimenre?.totalbarePCBToolingNRECost || 0) +
        (cost?.part4onetimenre?.totallineMachineNRECost || 0) +
        (cost?.part4onetimenre?.totalstensilNRECost || 0)
      );
    });

    this.sellingTotalForEachRow = this.totalPartAForEachRow.map((value: any, index: any) =>
      value + (this.totalPartBForEachRow[index] || 0) + (this.totalPartCForEachRow[index] || 0)
    );

    // Final Total = Part A + Part B + Part C + Part D
    // this.finalTotalForEachRow = this.totalPartAForEachRow.map((value: any, index: any) =>
    //   value + (this.totalPartBForEachRow[index] || 0) + (this.totalPartCForEachRow[index] || 0) + (this.totalPartDForEachRow[index] || 0)
    // );

    this.updateFinalTotals();
  }

  // calculatePCBAssemblyCost(index: number): number {
  //   const cost = this.totalFinalCosts[index]?.part2processcost;
  //   const pcbCount = this.totalFinalCosts[index]?.qty || 0; // Get PCB count dynamically

  //   if (!cost) return 0; // Handle undefined case gracefully

  //   const totalSMTCost = cost?.totalSMTCost || 0; // Example: 8.1
  //   const totalThroughHoleCost = cost?.totalThroughHoleCost || 0; // Example: 0.3

  //   let smtRate = 0;
  //   let thRate = 0;

  //   // Apply SMT cost calculation based on PCB count
  //   if (pcbCount > 1000) {
  //     smtRate = 0.30;
  //   } else {
  //     smtRate = 0.40;
  //   }

  //   // Apply TH cost calculation based on PCB count
  //   if (pcbCount < 200) {
  //     thRate = 2;
  //   } else if (pcbCount > 1000) {
  //     thRate = 1;
  //   } else {
  //     thRate = 1.5;
  //   }

  //   const smtCost = totalSMTCost * smtRate;
  //   const thCost = totalThroughHoleCost * thRate;
  //   const finalTotal = smtCost + thCost;

  //   return finalTotal;
  // }

  initializeTotals(): void {
    this.totalPartBForEachRow = this.totalFinalCosts.map(() => 0);
  }

  updatePartBTotal() {
    this.totalPartBForEachRow = this.totalFinalCosts.map((cost: any, index: number) => {
      const pcbAssemblyCost = cost?.part2processcost?.totalSMTThroughHoleCost || 0;
      const testingCost = cost?.part2processcost?.totaltestingProcessCost || 0;
      const xrayCost = cost?.part2processcost?.totalxRayPartCost || 0;
      const packagingCost = cost?.part2processcost?.totalpackagingBoxPCBACost || 0;

      return pcbAssemblyCost + testingCost + xrayCost + packagingCost;
    });

    // Sum the total of all rows
    this.grandTotalPartB = this.totalPartBForEachRow.reduce((acc: any, val: any) => acc + val, 0);
  }

  bareMinimum(cost: number): number {
    if (isNaN(cost)) return 0;  // Return 0 or some default value if the cost is not a valid number.
    const part4 = this.totalfinalcost?.part4onetimenre;
    if (part4?.layerSize < 6) {
      this.totalBareMinimum = (cost * 30) / 100;
      return cost + this.totalBareMinimum;
    }
    return cost;
  }

  TotalDBareMinimum(cost: number) {
    const part4 = this.totalfinalcost?.part4onetimenre;
    if (part4.layerSize < 6) {
      part4.layerSize < 6 ? this.partDBareMinimum = cost + this.totalBareMinimum : this.totalPartD;
      return this.partDBareMinimum
    }
    return cost;
  }

  perUnitPartDBareMinimum(cost: number) {
    const part4 = this.totalfinalcost?.part4onetimenre;
    if (part4.layerSize < 6) {
      this.totalBareMinimum = (cost * 30) / 100;
      return cost + this.totalBareMinimum + this.perUnitPartD;
    }
    return cost;
  }

  openModal(openMissingComp: any, index: number) {
    const quotation = this.quotationViewDetails[index];
    const ebomCostObj = quotation.totalquotationcost[4]?.EBomCost;
    
    this.remainingMPNPrice = ebomCostObj.mouserPrice?.remainingMPNPrice || [];
  
    this.modalService.open(openMissingComp, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'lg'
    });
  }

  calculateValues() {
    const part1rmccost = this.totalfinalcost?.part1rmccost || {};
    const part2processcost = this.totalfinalcost?.part2processcost || {};
    const part3others = this.totalfinalcost?.part3others || {};
    const part4onetimenre = this.totalfinalcost?.part4onetimenre || {};

    // Calculate Part A
    this.perUnitPartA =
      (part1rmccost?.totalEbomCost || 0) +
      (part1rmccost?.totalBarePcbCost || 0) +
      (part1rmccost?.totalFreightCost || 0) +
      (part1rmccost?.totalInsuranceCost || 0) +
      (part1rmccost?.totalDutiesPartsPCBCost || 0) +
      (part1rmccost?.totalClearingBankChargeCost || 0) +
      (part1rmccost?.totalMortalityCost || 0);

    // Calculate Part B including the input costs
    this.perUnitPartB =
      (part2processcost?.totalSMTCost?.totalSMTCost || 0) * 0.40 +
      (part2processcost?.totalThroughHoleCost?.totalAssemblyCost || 0) * 2 +
      (this.totaltestingProcessCost || 0) +  // Use the calculated testing cost
      (this.totalpackagingProcessCost || 0) + // Use the calculated x-ray cost
      (part2processcost?.totalpackagingBoxPCBACost || 0);

    // Calculate Part C including inventory cost
    this.perUnitPartC =
      (this.totalinventoryProcessCost || 0) + // Use the calculated inventory cost
      (part3others?.totaloverheadsCost || 0) +
      (part3others?.totalmarkupCost || 0);

    this.perUnitPartD =
      (part4onetimenre?.totalbarePCBToolingNRECost || 0) +
      (part4onetimenre?.totallineMachineNRECost || 0) +
      (part4onetimenre?.totalstensilNRECost || 0);

    // Calculate per unit prices
    this.perUnitSellingPrice = this.perUnitPartA + this.perUnitPartB + this.perUnitPartC;
    this.perUnitFinalPrice = this.perUnitSellingPrice + this.perUnitPartD;

    this.updateTotalValues();
  }


  updateTotalValues() {
    // Update multiplied totals
    this.totalPartA = this.perUnitPartA * this.selectedMultiplier;
    this.totalPartB = this.perUnitPartB * this.selectedMultiplier;
    this.totalPartC = this.perUnitPartC * this.selectedMultiplier;
    this.totalPartD = this.perUnitPartD * this.selectedMultiplier;
    // Calculate final totals
    this.totalSellingPrice = this.totalPartA + this.totalPartB + this.totalPartC;
    this.totalFinalPrice = this.totalSellingPrice + this.totalPartD;
  }

  onMultiplierChange() {
    this.updateTotalValues();
  }

  calculateTestingCost(index?: number) {
    if (index !== undefined) {
      if (this.testingInput === 0) {
        return 0;
      }
      const testingCost = this.totalFinalCosts[index]?.part2processcost?.totaltestingProcessCost || 0;
      return testingCost * this.testingInput;
    }
    this.updateTotals();
    return 0;
  }

  calculateXRayCost(index?: number) {
    if (index !== undefined) {
      if (this.packagingInput === 0) {
        return 0;
      }
      const xRayCost = this.totalFinalCosts[index]?.part2processcost?.totalxRayPartCost || 0;
      return xRayCost * this.packagingInput;
    }
    this.updateTotals();
    return 0;
  }

  calculateinventoryCost(index?: number) {
    if (index !== undefined) {
      if (this.inventoryInput === 0) {
        return 0;
      }
      const inventoryCost = this.totalFinalCosts[index]?.part3others?.totalinventoryCarryingCost || 0;
      return inventoryCost * this.inventoryInput;
    }
    this.updateTotalsForPartC();
    return 0;
  }

  updateTotals(): void {
    this.totalPartBForEachRow = this.totalFinalCosts.map((cost: any, index: any) => {
      const pcbCost = cost?.part2processcost?.totalSMTThroughHoleCost || 0;
      const testingCost = this.calculateTestingCost(index);
      const xRayCost = this.calculateXRayCost(index);
      const packagingCost = cost?.part2processcost?.totalpackagingBoxPCBACost || 0;
      return pcbCost + testingCost + xRayCost + packagingCost;
    });
    this.updateFinalTotals(); 
  }

  updateTotalsForPartC() {
    this.totalPartCForEachRow = this.totalFinalCosts.map((cost: any, index: any) => {
      const inventoryCost = this.calculateinventoryCost(index);
      const storageCost = cost?.part3others?.totaloverheadsCost || 0;  // Add other Part C costs if needed
      const handlingCost = cost?.part3others?.totalmarkupCost || 0;
  
      return inventoryCost + storageCost + handlingCost;
    });
    this.updateFinalTotals(); 
  }

  updateFinalTotals(): void {
    this.sellingTotalForEachRow = this.totalFinalCosts.map((cost: any, index: any) => {
      const partA = this.totalPartAForEachRow[index] || 0;
      const partB = this.totalPartBForEachRow[index] || 0;
      const partC = this.totalPartCForEachRow[index] || 0;
      return partA + partB + partC; // ✅ Selling Price = A + B + C
    });

    this.finalTotalForEachRow = this.sellingTotalForEachRow.map((sellingTotal: number, index: number) => {
      const partD = this.totalPartDForEachRow[index] || 0;
      return sellingTotal + partD; // ✅ Final Price = Selling Price + D
    });
}

  updateTotalCommercials() {
    this.perUnitSellingPrice = this.perUnitPartA + this.perUnitPartB + this.perUnitPartC;
    this.perUnitFinalPrice = this.perUnitSellingPrice + this.perUnitPartD;

    // Update total prices based on selected multiplier
    this.totalSellingPrice = this.perUnitSellingPrice * this.selectedMultiplier;
    this.totalFinalPrice = this.perUnitFinalPrice * this.selectedMultiplier;
  }

  // calculatePCBAssemblyCost(): number {
  //   const totalSMTCost = this.totalfinalcost?.part2processcost?.totalSMTCost?.totalSMTCost || 0;
  //   const totalAssemblyCost = this.totalfinalcost?.part2processcost?.totalThroughHoleCost?.totalAssemblyCost || 0;

  //   if (this.selectedMultiplier < 200) {
  //     return totalSMTCost * 0.40 + totalAssemblyCost * 2;
  //   } else if (this.selectedMultiplier > 1000) {
  //     return totalSMTCost * 0.30 + totalAssemblyCost * 1;
  //   } else {
  //     return totalSMTCost * 0.40 + totalAssemblyCost * 1.5;
  //   }
  // }

  restrictInput(event: Event) {
    const input = event.target as HTMLInputElement;

    // Allow only numbers and prevent non-numeric input
    if (!/^\d*\.?\d*$/.test(input.value)) {
      input.value = input.value.slice(0, -1);  // Remove the non-numeric character
    }
  }

  final: any;
  finalC: any;


  get getFinalSellingPrice() {
    return this.final + this.finalC + this.totalPartA;
  }

  get CalcPartB() {
    const testingInput = this.testingInput ? this.totalfinalcost?.part2processcost?.totaltestingProcessCost * this.testingInput : 0;
    const packagingInput = this.packagingInput ? this.totalfinalcost?.part2processcost?.totalxRayPartCost * this.packagingInput : 0;
    this.final = testingInput ? testingInput + packagingInput + this.perUnitPartB - this.totalfinalcost?.part2processcost?.totaltestingProcessCost : testingInput + packagingInput + this.perUnitPartB
    return this.final;
  }

  get CalcPartC() {
    const inventoryInput = this.inventoryInput ? this.totalfinalcost?.part3others?.totalinventoryCarryingCost * this.inventoryInput : 0;
    this.finalC = inventoryInput ? inventoryInput + this.perUnitPartC - this.totalfinalcost?.part3others?.totalinventoryCarryingCost : inventoryInput + this.perUnitPartC
    return this.finalC;
  }

  getFinalTotalPrice() {
    return this.final + this.finalC + this.totalPartA + (this.partDBareMinimum ? this.partDBareMinimum : this.totalPartD);
  }

  getFinalPrice(value: any) {
    return value + this.totalBareMinimum;
  }

  get displayedTestingCost() {
    if (this.testingInput !== null && !isNaN(this.testingInput)) {
      return this.totaltestingProcessCost;
    }
    return this.totalfinalcost?.part2processcost?.totaltestingProcessCost || 0;
  }

  get displayedxRayCost() {
    if (this.packagingInput !== null && !isNaN(this.packagingInput)) {
      return this.totalpackagingProcessCost;
    }
    return this.totalfinalcost?.part2processcost?.totalxRayPartCost || 0;
  }

  get displayedInventoryCost() {
    if (this.inventoryInput !== null && !isNaN(this.inventoryInput)) {
      return this.totalinventoryProcessCost;
    }
    return this.totalfinalcost?.part3others?.totalinventoryCarryingCost || 0;
  }

  handleApiResponse(response: any) {
    if (response) {
      const data = this.mapApiDataToRows(response);
      this.dataSource.data = data;
      this.calculateTotalCost(data);
    } else {
    }
  }

  mapApiDataToRows(data: any[]): Row[] {
    const rows: Row[] = [];

    data.forEach(item => {
      // Safely access nested properties using optional chaining and nullish coalescing
      const pcbCost = item.PCBCost?.totalBarePcbCost ?? null;
      const smtCost = item.SMTCost?.totalSMTCost ?? null;
      const laborCost = item.LaberCost?.totalAssemblyCost ?? null;
      const nreCost = item.NRECost?.totalNRECost ?? null;
      const ebomCost = item.EBomCost?.mouserPrice?.price ?? null;
      const pcbPerUnit = item.PCBCost?.vPricePerSqCm ?? null;
      const smtPerUnit = item.SMTCost?.vPerJointCost ?? null;
      const laborPerUnit = item.LaberCost?.vPerJointCost ?? null;

      // Function to safely parse, round, and format the cost
      const formatCost = (cost: any): string => {
        if (cost === null || isNaN(parseFloat(cost))) {
          return 'N/A'; // Return 'N/A' for invalid or missing cost
        }

        // Parse the cost, round it, and add commas
        return Math.round(parseFloat(cost)).toLocaleString();
      };

      // Push rows with calculated and formatted costs
      if (pcbCost !== null) {
        rows.push({ name: 'PCB Cost', unit: `₹${pcbPerUnit}`, total: pcbCost === 0 ? 'Contact us for pricing' : `$ ${pcbCost}` });
      }
      if (smtCost !== null) {
        rows.push({ name: 'SMT Cost', unit: `₹${smtPerUnit}`, total: `$ ${smtCost}` });
      }
      if (laborCost !== null) {
        rows.push({ name: 'PCB Assebmly Price ', unit: `₹${laborPerUnit}`, total: `$ ${laborCost}` });
      }
      if (nreCost !== null) {
        rows.push({ name: 'NRE', unit: 'N/A', total: `$ ${nreCost}` });
      }
      if (ebomCost !== null) {
        rows.push({ name: 'E-BOM Cost', unit: 'N/A', total: `$ ${Math.round((ebomCost + Number.EPSILON) * 100) / 100}` });
      }
    });

    // Calculate total cost
    this.calculateTotalCost(rows);

    // Safely format the total cost
    const formattedTotalCost = isNaN(this.totalCost)
      ? 'N/A'
      : Math.round(this.totalCost).toLocaleString();
    // Add the total row
    rows.push({ name: 'Total', unit: '', total: `$ ${formattedTotalCost}` });

    return rows;
  }

  calculateTotalCost(data: Row[]) {
    this.totalCost = data.reduce((sum, row) => {
      // Extract numeric value from the formatted string
      const totalString = row.total.trim().replace(/[^\d.-]/g, '');
      const totalValue = parseFloat(totalString);

      if (!isNaN(totalValue) && isFinite(totalValue)) {
        return sum + totalValue;
      } else {
        return sum;
      }
    }, 0);
  }

  checkEBomCost() {
    const data = this.dataSource.data;
    // Find the E-BOM Cost row
    const ebomCostData = data.find(row => row.name === 'E-BOM Cost');
    this.hasRemainingMPNPrice = true;
  }


  // Get percentage of qoutation
  getPercentage(): void {
    let stopPolling = false;
    this.quotingService.getPercentage(this.projectID).subscribe(response => {
      if (response.data.CombinedCompletedPercentage === 100) {
        stopPolling = true; 
      }
    });
  
    // Set the interval to call the API every 15 seconds
    const intervalId = setInterval(() => {
      if (stopPolling) {
        clearInterval(intervalId); // Stop the interval if percentage is 100
      } else {
        this.quotingService.getPercentage(this.projectID).subscribe(response => {
          let percentage = Math.floor(response.data.CombinedCompletedPercentage); // Remove decimals
          let percentageCount = `${percentage}%`; // Format properly
          this.quotingService.updateQuotePercentage(percentageCount);
    
          if (percentage === 100) {
            stopPolling = true;
            clearInterval(intervalId);
          }
        });
      }
    }, 15000);
  }
}
